import { CommonModule } from '@angular/common';
import { AfterViewInit, booleanAttribute, Component, input, numberAttribute, OnInit, signal } from '@angular/core';

import { BaseComponent } from '@base/base.component';
import { Tag } from '@models';
import { StoreService } from '@services/store.service';

@Component({
    selector: 'vz-temp-info, [vz-temp-info]',
    template: `
        @if (!hidden()) {
            <div class="layout flex vz-panel-info" [ngClass]="CLASSES[type()]" [class.vz-temp-info-fs]="fs()" animate.enter="vza-show-h" animate.leave="vza-hide-h">
                @if (!noIcon()) {
                    <div class="fs-5xl ml05 mr1 mt05"><i [ngClass]="ICON[type()]"></i></div>
                }
                <div class="mr05 flex scroll-y"><ng-content /></div>
                <div><i class="vzi-close vz-btn-c op05 fs-s" (click)="hide()"></i></div>
            </div>
        }
    `,
    imports: [CommonModule],
    styles: `
        .vz-temp-info-fs {
            position: fixed;
            top: 0;
            right: 0;
            left: 0;
            bottom: 0;
            z-index: 99999;
            margin: 4px;
        }
    `,
    host: {
        '[class.hide]': 'hidden()',
        '[class.hidden]': 'hidden()',
        'class.vz-temp-info-fs': 'fs()'
    }
})
@Tag('TempInfoComponent')
export class TempInfoComponent extends BaseComponent implements OnInit, AfterViewInit {

    storeId        = input<string>('default-store-temp-info-id');
    timeout        = input(0, { transform: numberAttribute });
    type           = input<'default' | 'verbose' | 'success' | 'info' | 'warning' | 'danger'>('default');
    noIcon         = input(false, { transform: booleanAttribute });
    fsMobile       = input(false, { transform: booleanAttribute });

    hidden          = signal<boolean>(false);
    fs              = signal<boolean>(false);

    ICON = {
        'default': 'vzi-info',
        'verbose': 'vzi-chat1',
        'success': 'vzi-done',
        'info': 'vzi-info',
        'warning': 'vzi-warning',
        'danger': 'vzi-cancel-circle',
    };
    CLASSES = {
        'default': 'bc txt',
        'verbose': 'bc-l txt-l',
        'success': 'bc-ok bg-t-ok',
        'info': 'bc-a bg-t-a txt-a',
        'warning': 'bc-warn bg-t-warn txt-warn',
        'danger': 'bc-err bg-t-err txt-err',
    };

    constructor(protected _store: StoreService) {
        super();
    }

    ngOnInit(): void {
        this._S.hidden = this._store.state('prefs').subscribe(st => this.hidden.set(st.tempInfoHidden[this.storeId()]));
        if (!this.hidden() && this.timeout() > 0) {
            setTimeout(() => this.hidden.set(true), this.timeout());
        }
    }

    ngAfterViewInit(): void {
        const dim = Math.min(window.screen.availHeight, window.screen.availWidth);
        const k = 100;
        this.fs.set(this.fsMobile() && (k < 15 || dim < 640));
    }

    hide(): void {
        const tempInfoHidden = this._store.getState('prefs').tempInfoHidden;
        tempInfoHidden[this.storeId()] = true;
        this._store.patchState('prefs', { tempInfoHidden });
    }

}
